export default [
  // Main Page
  {
    path: 'products',
    name: 'website.products',
    component: () => import('@/views/website/products'),
  },

  // Create product
  {
    path: 'products/create',
    name: 'website.products.create',
    component: () => import('@/views/website/products/Create'),
  },

  // Update product
  {
    path: 'products/update/:id',
    name: 'website.products.update',
    props: true,
    component: () => import('@/views/website/products/Update'),
  },
  {
    path: 'products/books/:id',
    name: 'website.products.books',
    props: true,
    component: () => import('@/views/website/products/Books'),
  },
  {
    path: 'products/update/:id/add',
    name: 'website.products.variants.add',
    props: true,
    component: () => import('@/views/website/products/components/AddVariant'),
  },
  {
    path: 'products/update/:id/variants/:vId',
    name: 'website.products.variants.update',
    props: true,
    component: () => import('@/views/website/products/components/AddVariant'),
  },
  {
    path: 'products/bulk-edit',
    name: 'website.products.bulkEdit',
    props: true,
    component: () => import('@/views/website/products/BulkEdit'),
  },
  {
    path: 'products/gem-pages',
    name: 'website.products.gemPages',
    props: true,
    component: () => import('@/views/website/products/gemPage'),
  },
  {
    path: 'products/gem-pages/create',
    name: 'website.products.gemPages.create',
    props: true,
    component: () => import('@/views/website/products/gemPage/create'),
  },
  {
    path: 'products/gem-pages/:id',
    name: 'website.products.gemPages.update',
    props: true,
    component: () => import('@/views/website/products/gemPage/update'),
  },
  {
    path: 'products/:id/insight',
    name: 'website.products.insight',
    props: true,
    component: () => import('@/views/website/products/insight'),
  },
];
